/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibraryempty2Inputs */

const en_medialibraryempty2 = /** @type {(inputs: Medialibraryempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No assets yet`)
};

const de_medialibraryempty2 = /** @type {(inputs: Medialibraryempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Inhalte`)
};

/**
* | output |
* | --- |
* | "No assets yet" |
*
* @param {Medialibraryempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryempty2 = /** @type {((inputs?: Medialibraryempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryempty2(inputs)
	return de_medialibraryempty2(inputs)
});
export { medialibraryempty2 as "mediaLibraryEmpty" }